import { useMemo } from 'react';
import { GROUP_ORDER, VARIABLES, type VariableKey } from '../lib/census-variables';
import { useI18n } from '../lib/i18n';

export function VariableSelector({
  value,
  onChange,
}: {
  value: VariableKey;
  onChange: (v: VariableKey) => void;
}) {
  const { t } = useI18n();

  const byGroup = useMemo(() => {
    const map = new Map<string, typeof VARIABLES>();
    for (const g of GROUP_ORDER) map.set(g, []);
    for (const v of VARIABLES) map.get(v.group)!.push(v);
    return map;
  }, []);

  return (
    <div className="flex flex-col gap-3">
      <h2 className="display text-xs uppercase tracking-[0.2em] text-an-muted">
        {t('app.selector.title')}
      </h2>
      {GROUP_ORDER.map((group) => {
        const vars = byGroup.get(group) ?? [];
        if (!vars.length) return null;
        return (
          <div key={group}>
            <div className="mb-1 font-body text-[11px] uppercase tracking-widest text-an-muted">
              {t(`app.selector.group.${group}`)}
            </div>
            <div className="flex flex-wrap gap-1.5">
              {vars.map((v) => {
                const isActive = v.key === value;
                return (
                  <button
                    key={v.key}
                    type="button"
                    onClick={() => onChange(v.key)}
                    className={[
                      'display border px-2.5 py-1 text-[11px] uppercase tracking-wider transition',
                      isActive
                        ? 'border-an-black bg-an-black text-an-white'
                        : 'border-an-rule bg-an-white text-an-ink hover:bg-an-paper',
                    ].join(' ')}
                  >
                    {t(`var.${v.key}.short`)}
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
